import type {
  BackendErrorResponse,
  ParsedErrorDetail,
} from '../@types/backend-error-response';

function getDetailFromObject(errorObject: unknown) {
  if (typeof errorObject === 'object' && errorObject !== null) {
    if ('response' in errorObject) {
      return (errorObject as BackendErrorResponse)?.response?.error?.detail;
    }
    if ('detail' in errorObject) {
      return (errorObject as ParsedErrorDetail)?.detail;
    }
  }
}

export async function resolveBackendError(error: unknown) {
  let errorMessage: string | undefined;

  if (error instanceof Response) {
    try {
      const unknownError = (await error.json()) as unknown;
      errorMessage = getDetailFromObject(unknownError);
    } catch (parseError) {
      console.error('Error parsing the error message:', parseError);
    }
  }

  return errorMessage ?? getDetailFromObject(error);
}
